import Flex from '@decisiv/ui-components/lib/components/Flex';
import styled from 'styled-components';
import rem from 'polished/lib/helpers/rem';
import spacing from '@decisiv/design-tokens/lib/spacing';

export const FormContainer = styled(Flex)`
  flex-direction: column;
  gap: ${rem(spacing.base * 1)};
`;

export const InlineFields = styled(Flex)`
  gap: ${rem(spacing.base * 1)};
  flex-wrap: wrap;
`;
